"use client";

import React, { useEffect } from "react";
import { fetchNotifications, markAllNotificationsAsRead } from "../../../Redux/slice/notificationSlice";
import { useDispatch, useSelector } from "react-redux";
import { useMarkAllAsReadMutation } from "../../../Redux/apis/notifications";
import { toast } from "react-toastify";
function NotificationFooter({
  activeTab
}) {
  const dispatch = useDispatch();
  const notificationData = useSelector(state => state.notifications?.notifications);
  const [markAllAsRead, response] = useMarkAllAsReadMutation();
  const users = useSelector(state_0 => state_0?.userData?.userData?.user);
  const hasNotificationsForTab = () => {
    if (!notificationData?.length) return false;
    if (activeTab === 'all') return true;
    if (activeTab === 'message') return notificationData.some(n => n?.type === 'message');
    if (activeTab === 'meetings') return notificationData.some(n_0 => n_0?.type === 'meeting');
    return false;
  };
  const handleMarkAllAsRead = async () => {
    try {
      let notificationIds = notificationData?.map(notification => notification?._id);
      if (notificationIds?.length) {
        await markAllAsRead({
          notificationIds
        });
      }
      // Dispatch the action to update the store
      dispatch(markAllNotificationsAsRead());
    } catch (error) {
      console.error("Failed to mark all notifications as read:", error);
      toast.error('Something went wrong!');
    }
  };
  useEffect(() => {
    if (response.isError && response.status === "rejected" && response?.error?.status === 400) {
      toast.error(response?.error?.data?.message);
      if (users && users?._id) {
        dispatch(fetchNotifications({
          userId: users?._id
        }));
      }
    }
  }, [response]);
  return <footer className="flex overflow-hidden flex-col justify-center items-end px-3 sm:px-8 py-3 sm:py-5 w-full text-[10px] sm:text-xs font-medium text-right border-t border-neutral-400 border-opacity-30 text-neutral-600">
      {hasNotificationsForTab() && <button className="flex gap-1 items-center px-2 py-1 rounded border border-solid border-[#1E5EFF]" onClick={handleMarkAllAsRead}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5 sm:w-4 sm:h-4" viewBox="0 0 16 16" fill="none">
          <path fillRule="evenodd" clipRule="evenodd" d="M11.0204 4.31313C11.2156 4.50839 11.2156 4.82498 11.0204 5.02024L4.35371 11.6869C4.25995 11.7807 4.13277 11.8334 4.00016 11.8334C3.86755 11.8334 3.74037 11.7807 3.64661 11.6869L0.979941 9.02022C0.784681 8.82495 0.784681 8.50842 0.979941 8.31315C1.1752 8.11789 1.49179 8.11789 1.68705 8.31315L4.00016 10.6262L10.3133 4.31313C10.5086 4.11787 10.8251 4.11787 11.0204 4.31313ZM15.0204 4.31313C15.2156 4.50838 15.2156 4.82497 15.0204 5.02023L8.35403 11.6869C8.15876 11.8822 7.84223 11.8822 7.64696 11.687L6.64666 10.687C6.45137 10.4918 6.45132 10.1752 6.64655 9.97982C6.84176 9.78455 7.15836 9.78449 7.35369 9.97975L8.00043 10.6263L14.3133 4.31314C14.5085 4.11787 14.8251 4.11787 15.0204 4.31313Z" fill="#1E5EFF" />
        </svg>
        {" "}
        <span className="self-stretch my-auto text-[#1E5EFF] font-poppins font-medium text-[10px] sm:text-[12px]">Mark all as read</span>
      </button>}
    </footer>;
}
export default NotificationFooter;